//# sourceMappingURL=ai_config.mjs.map
/// <reference types="./ai_config.d.mts" />
import * as $ai_config from "../../../data_types/data/ai_config.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $ai_config_effects from "../../admin/effects/ai_config.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList } from "../../gleam.mjs";

export function unwrap_ai_config(store, next) {
  let ai_config = $store.organization_ai_config(store);
  let $ = $remote.read(ai_config);
  if ($ instanceof Ok) {
    let ai_config$1 = $[0];
    return next(ai_config$1);
  } else {
    return [store, $effect.none()];
  }
}

export function update(store, msg) {
  if (msg instanceof $msg.ApiStartedLoadingAiConfig) {
    let org_id = msg.org_id;
    let _pipe = $dict.insert(
      store.organizations_ai_config,
      org_id,
      new $remote.Loading(),
    );
    let _pipe$1 = ((_capture) => {
      return $store.set_organizations_ai_config(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedAiConfig) {
    let org_id = msg.org_id;
    let ai_config = msg.value;
    let _block;
    if (ai_config instanceof Some) {
      let ai_config$1 = ai_config[0];
      _block = $store.set_ai_config(store, ai_config$1);
    } else {
      let _pipe = store.organizations_ai_config;
      let _pipe$1 = $dict.insert(
        _pipe,
        org_id,
        new $remote.Errored("ai_config:none"),
      );
      _block = ((_capture) => {
        return $store.set_organizations_ai_config(store, _capture);
      })(_pipe$1);
    }
    let _pipe = _block;
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedAiConfigs) {
    let ai_configs = msg.ai_configs;
    let _block;
    let $ = store.organizations;
    if ($ instanceof $remote.Loaded) {
      let organizations = $[0][1];
      _block = $list.map(
        organizations,
        (org) => { return [org.id, new $remote.Errored("ai_config:none")]; },
      );
    } else {
      _block = toList([]);
    }
    let without_config = _block;
    let loaded = $list.map(
      ai_configs,
      (ai_config) => {
        return [ai_config.org_id, new $remote.Loaded(ai_config)];
      },
    );
    let _pipe = $dict.from_list($list.append(without_config, loaded));
    let _pipe$1 = ((_capture) => {
      return $store.set_organizations_ai_config(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiSavedAiConfig) {
    let ai_config = msg.ai_config;
    let _pipe = store;
    let _pipe$1 = $store.set_ai_config(_pipe, ai_config);
    return $pair.new$(_pipe$1, $effect.none());
  } else {
    let value = msg.value;
    return unwrap_ai_config(
      store,
      (ai_config) => {
        let updated = $ai_config.set_website_prompt_config(ai_config, value);
        let store$1 = $store.set_ai_config(store, updated);
        return [store$1, $ai_config_effects.set_ai_config(updated)];
      },
    );
  }
}
